import React from "react";
import { Popup } from "@components/index";

/**
 * Props interface following TypeScript naming convention
 */
interface LayoutContainerProps {
  children: React.ReactNode;
}

/**
 * Layout container component
 * Provides consistent layout structure with popup support
 * Note: memo is not used here because `children` is a new reference on every
 * parent render, defeating shallow comparison entirely.
 */
export function LayoutContainer({
    children
}: LayoutContainerProps): React.ReactElement {
    return (
        <div className="layout-container min-h-screen flex flex-col">
            <main className="main-content flex-1">
                {children}
            </main>
            <Popup />
        </div>
    );
}

export default LayoutContainer;
